import React, { useState, useEffect } from 'react';
import "./TicTacToe.css";

const TicTacToe = () => {
  const [board, setBoard] = useState(Array(9).fill(null));
  const [isXNext, setIsXNext] = useState(true);
  const [isGameStarted, setIsGameStarted] = useState(false); // Initially set to false
  const [userWins, setUserWins] = useState(0); // Track user wins
  const [aiWins, setAiWins] = useState(0); // Track AI wins
  const [FirstRound, setFirstRound] = useState(true)

  useEffect(() => {
    if (!isGameStarted) {
      setIsGameStarted(true); // Set to true after the first game starts
    }

    if (!isXNext && !calculateWinner(board) && !isDraw(board)) {
      const shouldMakeMistake = Math.random() < 0.2; // 20% chance to make a mistake
      const bestMove = getBestMove(board, 'O');
      const move = shouldMakeMistake ? getRandomMove(board) : bestMove;
      handleClick(move);
    }
  }, [isXNext, isGameStarted]);

  const handleClick = (index) => {
    if (!isGameStarted) return;
    setFirstRound(false);
    const newBoard = [...board];
    if (newBoard[index] || calculateWinner(board) || isDraw(board)) return;
    newBoard[index] = isXNext ? 'X' : 'O';
    setBoard(newBoard);
    setIsXNext(!isXNext);

    const winnerInfo = calculateWinner(newBoard);
    if (winnerInfo) {
      if (winnerInfo.winner === 'X') {
        setUserWins(prevWins => prevWins + 1); // Increment user wins
      } else {
        setAiWins(prevWins => prevWins + 1); // Increment AI wins
      }
    }
  };

  const calculateWinner = (squares) => {
    const lines = [
      [0, 1, 2],
      [3, 4, 5],
      [6, 7, 8],
      [0, 3, 6],
      [1, 4, 7],
      [2, 5, 8],
      [0, 4, 8],
      [2, 4, 6],
    ];
    for (let i = 0; i < lines.length; i++) {
      const [a, b, c] = lines[i];
      if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
        return { winner: squares[a], line: lines[i] };
      }
    }
    return null;
  };

  const isDraw = (squares) => {
    return squares.every(square => square !== null) && !calculateWinner(squares);
  };

  const startNewGame = () => {
    setBoard(Array(9).fill(null));
    setIsXNext(true);
    setIsGameStarted(true);
  };

  const getBestMove = (board, player) => {
    const opponent = player === 'O' ? 'X' : 'O';
    const emptySquares = board.reduce((acc, val, idx) => val === null ? acc.concat(idx) : acc, []);

    // Check for a winning move
    for (let i = 0; i < emptySquares.length; i++) {
      const newBoard = [...board];
      newBoard[emptySquares[i]] = player;
      if (calculateWinner(newBoard)) {
        return emptySquares[i];
      }
    }

    // Block opponent's winning move
    for (let i = 0; i < emptySquares.length; i++) {
      const newBoard = [...board];
      newBoard[emptySquares[i]] = opponent;
      if (calculateWinner(newBoard)) {
        return emptySquares[i];
      }
    }

    // Take center if available
    if (emptySquares.includes(4)) {
      return 4;
    }

    // Take a corner if available
    const corners = [0, 2, 6, 8];
    for (let i = 0; i < corners.length; i++) {
      if (emptySquares.includes(corners[i])) {
        return corners[i];
      }
    }

    // Take any remaining square
    return emptySquares[Math.floor(Math.random() * emptySquares.length)];
  };

  const getRandomMove = (board) => {
    const emptySquares = board.reduce((acc, val, idx) => val === null ? acc.concat(idx) : acc, []);
    return emptySquares[Math.floor(Math.random() * emptySquares.length)];
  };

  const winnerInfo = calculateWinner(board);
  const winner = winnerInfo ? winnerInfo.winner : null;
  const draw = isDraw(board);
  const status = winner 
    ? (winner === "X" ? `Congratulations You Won!` : `Sorry, Bad Luck`) 
    : draw 
    ? `It's a draw!` 
    : isGameStarted
    ? `Your Wins: ${userWins} | Bot Wins: ${aiWins}`
    : 'Let\'s play again!';

  return (
    <div className="game">
        <div className="game-info mb-4">{FirstRound ? `Let\'s play Tic-tac-toe` : status}</div>
        <div className="game-board">
            {board.map((value, index) => (
                <button
                    className={`square ${FirstRound ? 'first-round-square' : winnerInfo && winnerInfo.line.includes(index) ? 'highlight' : ''}`}
                    key={index}
                    onClick={() => handleClick(index)}
                >
                    {value}
                </button>
            ))}
        </div>
        {(winner || draw) && (
            <div onClick={startNewGame} className={draw ? 'btn mt-6' : winner === "X" ? 'btn alt-btn mt-6' : 'btn alt-btn-red mt-6'}>
                <div className='btn_text'><span>{`>.  `}</span>New Game</div>
            </div>
        )}
    </div>
  );
};

export default TicTacToe;
